// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"70e720eb","9":"7193a0cd","512":"78a90cdc","533":"238c881c","608":"55041edc","895":"72ec9680","954":"183e7a53"}[chunkId] + ".chunk.js";
};